$(() => {
  $('.hide-until-ready').removeClass('hide-until-ready');
})
